import config from '../common/config';
import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Grid, Cell } from 'react-flexr';

import ProductCategory from '../common/product-category';
import { SearchPanel } from '../common/search';
import TagFilter from '../common/tagFilter';
import Showcase from '../common/showcase';

import { fromJS, Set } from 'immutable';

const REMOVE_ALL = 'Fjern alle';
const ADD_ALL = 'Vælg alle';

const MIN_AKASSE = 'min A-kasse';
const LEDERNE = 'Lederne';
const KRIFA = 'Krifa';
const FTF_A = 'FTF-A';
const FRIE_FUNKTIONÆRER = 'Frie';
const FAGLIG_HUS = 'Det faglige hus';
const CA = 'CA';
const MA = 'MA';
const ASE = 'ase';
const AKADEMIKERNES_AKASSE = 'Akademikernes ambitiøse A-Kasse';
const BUSINESS_DANMARK = 'Business Danmark';
const THREE_F = '3F';
const AKASSER = [
  MIN_AKASSE,
  LEDERNE,
  KRIFA,
  FTF_A,
  FRIE_FUNKTIONÆRER,
  FAGLIG_HUS,
  CA,
  MA,
  ASE,
  AKADEMIKERNES_AKASSE,
  BUSINESS_DANMARK,
  THREE_F
];

const FREE_STUDENTS = 'Gratis for studerende';

class Offers extends ProductCategory {
  static defaultProps = {
    category: 'akasse'
  };

  constructor(props) {
    super(props);

    this.state = this.mapPropsToState(props, {
      offerType: 'a-kasse',
      ...this.state,
      defaultFilters: {
        retirement: false,
        union: false,
        freeForStudents: false,
        tags: []
      },
      filters: {
        retirement: false,
        union: false,
        freeForStudents: false,
        tags: [],
        ...(this.state.filters || {})
      }
    });
  }

  resetFilter() {
    const filters = {
      ...(this.state.filters || {}),
      retirement: false,
      union: false,
      freeForStudents: false,
      tags: []
    };
    
    this.setState({
      filters,
      filter: this.createFilter(filters)
    });
  }

  createFilter(filters) {
    this.updateFiltersUsed(filters);
    return offers =>
      offers.filter(offer => {
        const tags = Array.from(offer.get('usps'));
        const services = Array.from(offer.getIn(['_raw', 'services']));
        const filteredTags = filters.tags;

        const lowerCaseTags = tags.map(i => i.toLowerCase());
        const lowerCaseServices = services.map(i => i.toLowerCase());
        const lowerCaseProvider = offer.get('provider').toLowerCase().trim().replace('-', ' ');

        for (let idx = 0; idx < filteredTags.length; idx++) {
          const tag = filteredTags[idx];
          if (
            !lowerCaseServices.includes(tag) &&
            !lowerCaseTags.includes(tag) && 
            !tags.includes(tag) &&
            !services.includes(tag) &&
            tag.toLowerCase() !== lowerCaseProvider
            ) {
            return false;
          }
        }

        return true;
      });
  }

  serialiseOffer(offer) {
    const tags = offer.get('tags') ? offer.get('tags').toJS() : [];
    const manualTags = offer.get('manualTags') ? Array.from(offer.get('manualTags')) : [];
    const mergedTags = tags.reduce((acc, tag) => {
      if(!acc.includes(tag)) {
        acc.push(tag);
      }
      return acc;
    }, manualTags || []).filter(Boolean);

    return fromJS({
      id: offer.get('_id'),

      provider: offer.get('provider'),
      product: offer.get('product'),
      // logo: `${config.path.images}/${offer.get('imageUrl')}`,
      logo:
        offer.getIn(['image', 'hash']) &&
        `${config.images}${offer.getIn(['image', 'hash'])}`,
      link: `/redirect/${offer.get('uuid')}`,
      orderText: 'Indmelding',

      details: [
        {
          value: offer.get('professions').size
            ? offer.get('professions').join(', ')
            : 'Alle',
          label: 'Faggrupper',
          labelAbove: true
        },
        Math.ceil(offer.getIn(['monthlyPrice', 'union'])) > 0
          ? {
              value: Math.ceil(offer.getIn(['monthlyPrice', 'union'])),
              unit: 'kr./md.',
              label: 'Fagforening'
            }
          : null,
        Math.ceil(offer.getIn(['monthlyPrice', 'akasse'])) > 0
          ? {
              value: Math.ceil(offer.getIn(['monthlyPrice', 'akasse'])),
              unit: 'kr./md.',
              label: 'Akasse'
            }
          : null,
        offer.get('satisfaction')
          ? {
              value: offer.get('satisfaction'),
              unit: '/ 10',
              label: 'Trustpilot',
              class: 'trustpilot'
            }
          : null
      ].filter(Boolean),

      price: {
        value:
          offer.get('price') ? offer.get('price') : (Math.ceil(offer.getIn(['monthlyPrice', 'akasse'])) +
          Math.ceil(offer.getIn(['monthlyPrice', 'union']))),
        unit: 'kr.',
        label: 'Pris pr. md.'
      },

      usps: []
        .concat(mergedTags, offer.get('services').toJS())
        .filter(Boolean),
      productDescription: offer.get('productDescription'),
      discountCode: offer.get('discountCode'),

      _raw: offer
    });
  }

  createSearchDisplay(filters) {
    const display = [];
    return display;
  }

  render() {
    const { offers, filter, filters, showcases } = this.state;
    return (
      <Grid>
        <Cell size='3/12' portable='1/1'>
          <SearchPanel
            title={'A-kasse'}
            filter={filter}
            results={offers}
            filterTexts={this.createSearchDisplay(filters)}
          >
            <TagFilter
              headline={'Tags'}
              feed={this.state.feed}
              offerType={this.state.offerType}
              items={offers}
              filters={filters}
              checkboxOnChange={this.tagsOnChange}
            />
          </SearchPanel>
        </Cell>
        <Cell>
          <Showcase list={showcases} orderText='Se Tilbud' site_id={this.state.siteId} feed={this.state.feed} url={this.state.url} filters_used={this.state.filtersUsed}/>
          {this.renderResults(null, this.resetFilter.bind(this))}
        </Cell>
      </Grid>
    );
  }
}

export default connect(({ akasse: { offers } }) => ({ offers }))(
  withRouter(Offers)
);
